import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en/translation.json';
import fr from '../locales/fr/translation.json';
import { resolveInitialLocale } from './resolveInitialLocale';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
};

i18n.use(initReactI18next).init({
  resources,
  lng: resolveInitialLocale(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React échappe déjà les valeurs
  },
  supportedLngs: ['en', 'fr'],
});

export default i18n;
